var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hapi Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49883 4.99873C3.49883 4.44637 3.94661 3.99858 4.49898 3.99858H13.5003C14.0527 3.99858 14.5004 4.44637 14.5004 4.99873V5.99888C14.5004 6.55124 14.9482 6.99903 15.5006 6.99903C16.053 6.99903 16.5007 6.55124 16.5007 5.99888V4.99873C16.5007 3.34163 15.1574 1.99829 13.5003 1.99829H4.49898C2.84188 1.99829 1.49854 3.34163 1.49854 4.99873V14.0001C1.49854 15.6572 2.84188 17.0005 4.49898 17.0005H5.49912C6.05149 17.0005 6.49927 16.5527 6.49927 16.0003C6.49927 15.448 6.05149 15.0002 5.49912 15.0002H4.49898C3.94661 15.0002 3.49883 14.5524 3.49883 14.0001V4.99873ZM11.5 8.99947C9.84291 8.99947 8.49957 10.3428 8.49957 11.9999V21.0012C8.49957 22.6583 9.84291 24.0017 11.5 24.0017H20.5013C22.1584 24.0017 23.5018 22.6583 23.5018 21.0012V11.9999C23.5018 10.3428 22.1584 8.99947 20.5013 8.99947H11.5ZM10.4999 11.9999C10.4999 11.4475 10.9476 10.9998 11.5 10.9998H20.5013C21.0537 10.9998 21.5015 11.4475 21.5015 11.9999V21.0012C21.5015 21.5536 21.0537 22.0014 20.5013 22.0014H11.5C10.9476 22.0014 10.4999 21.5536 10.4999 21.0012V11.9999Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3f9abee5c11bd6b9d49f1e0d614b9ba9.svg";
export { ForwardRef as ReactComponent };